export const SORTING_ALG_PROJECT_PATH = 'sorting-algorithm-visualizer';
export const PATHFINDER_PROJECT_PATH = 'pathfinder';
export const TREE_PROJECT_PATH = 'binary-tree-traverser';
export const BLOG_PATH = 'journal';
export const PHOTOS_PATH = 'photos';
export const CONTACT_PATH = 'contact';
export const FEATURED_COLLECTION_ID = 'featured';
export const FEATURED_PHOTOS_PATH = `${PHOTOS_PATH}/featured`;
export const BLOG_BUILDER_PATH = `${BLOG_PATH}/builder`;
export const PHOTO_BUILDER_PATH = `${PHOTOS_PATH}/builder`;
export const HOME_PATH = '/';
export const PROD_API_PATH = 'https://quuy709ivh.execute-api.us-east-1.amazonaws.com/prod';
export const BETA_API_PATH = 'https://1faykhomu5.execute-api.us-east-1.amazonaws.com/prod';
export const BASE_API_PATH = window.location.hostname === 'mikebrauninger.com' ? PROD_API_PATH : BETA_API_PATH;
export const PROD_MEASUREMENT_ID = 'G-HB5XREV2NY';
export const BETA_MEASUREMENT_ID = 'G-0EZHTFRHC5';
